// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Nt_J","title":"Images45_title__U6ku9","images":"Images45_images__KlYy3"};